export const desktop = {
  sidebarWidth: 345,
  sidebarWidthXXL: 225,
  sidebarWidthXL: 144,
  sidebarWidthLG: 144,
  topHeight: 94,
  cellHeight: 70,
  scrollbar: 3,
  modalHeader: 60,
  modalFooter: 60,
  breakXXL: 1320,
  breakXL: 1200,
  breakLG: 960,
}
